module.exports = __webpack_public_path__ + "img/playgrounds-in-motion_mobile.8d6f17f.jpg";